@let obs =
  {
    phone: phone$ | async,
    isDesktopLgUp: isDesktopLgUp$ | async,
    telegramLink: telegramLink$ | async,
  };

@if (obs.phone) {
  @if (!obs.isDesktopLgUp || (obs.isDesktopLgUp && !obs.telegramLink)) {
    <a
      class="link-white link-hover-orange link-hover-underlined phone"
      [href]="'tel:' + (obs.phone | sdReplace: '[^0-9]+' : '')"
    >
      {{ obs.phone }}
    </a>
  }

  @if (obs.isDesktopLgUp && obs.telegramLink) {
    <a class="phone link-white link-hover-orange link-hover-underlined" [href]="obs.telegramLink" target="_blank">
      {{ obs.phone }}
    </a>
  }
}
